import React from "react";
import * as CSSTransition from "react-transition-group/CSSTransition";

import { GuestAccordionRow } from "./index";

interface IProps {
  place: server.dto.LegacyGuestlistPlace
  isSearching: boolean
}

interface IState {
  collapsed: boolean
}

class GuestAccordionSection extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = { collapsed: true };
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.shouldGetCollapsed(prevProps, prevState)) {
      this.setState({ collapsed: true });
    } else if (this.shouldGetUncollapsed(prevProps, prevState)) {
      this.setState({ collapsed: false });
    }
  }

  private readonly shouldGetCollapsed = (_: IProps, prevState: IState) => this.props.place.guests.length === 0 &&
    this.props.isSearching &&
    !prevState.collapsed &&
    !this.state.collapsed;

  private readonly shouldGetUncollapsed = (_: IProps, prevState: IState) => this.props.place.guests.length > 0 &&
    this.props.isSearching &&
    prevState.collapsed &&
    this.state.collapsed;

  private readonly isFull = (): boolean => {
    const { place } = this.props;
    return place.usedPlaces >= place.availableSpots;
  };

  private readonly getCheckmark = (): JSX.Element => <i className="small icon-checked margin-right" />;

  private readonly getHoverableClass = (): string => this.props.place.guests.length === 0 ? "" : "hoverable";

  private readonly getBackgroundColorClass = (): string => {
    const { place } = this.props;

    if (place.guests.length === 0) {
      return "darkgray-bg";
    }

    return "gray-bg";
  };

  private readonly onCollapseClick = (event) => {
    event.preventDefault();

    if (this.props.place.usedPlaces === 0) {
      return null;
    }

    this.setState({ collapsed: !this.state.collapsed });
  };

  private readonly getCollapseImg = (): string => {
    if (this.props.place.guests.length === 0) {
      return "";
    }
    return this.state.collapsed ? "icon-angle-up" : "icon-angle-down";
  };

  private readonly getGuestCount = (): string => {
    const { place } = this.props;

    if (this.props.isSearching) {
      return "";
    }
    const placesLeft = RESX.Guestlist.PlacesLeft.replace("{0}", place.emptyPlaces.toString());
    const placesTotal = RESX.Guestlist.PlacesTotal.replace("{0}", place.availableSpots.toString());
    return `${placesLeft} / ${placesTotal}`;
  };

  private readonly getCssSize = (): string => {
    const { length } = this.props.place.guests;
    if (length < 5) {
      return "small";
    }
    if (length < 10) {
      return "medium";
    }
    if (length < 15) {
      return "large";
    }
    if (length < 20) {
      return "x-large";
    }

    return "xx-large";
  };

  public render(): JSX.Element {
    const { place, isSearching } = this.props;

    return (
      <div>
        <div onClick={this.onCollapseClick} className={`flex padding subtitle-text-regular margin-bottom-mini ${this.getHoverableClass()} ${this.getBackgroundColorClass()}`}>
          <div className="grow1">
            {place.entryType.name}
            &nbsp;
            -
            &nbsp;
            {this.getGuestCount()}
            &nbsp;&nbsp;
            {this.isFull() && !isSearching ? this.getCheckmark() : null}
          </div>
          <div className="margin-left-small">
            <button className={this.getCollapseImg()} style={{ backgroundColor: "Transparent", color: "black", outline: "none" }} onClick={this.onCollapseClick}></button>
          </div>
        </div>
        <CSSTransition in={!this.state.collapsed} classNames={`list-with-gaps line-layout guest-${this.getCssSize()} guestlist-guest`} timeout={{ enter: 200, exit: 200 }} unmountOnExit={true}>
          <div>
            <div className="list-with-gaps-body">
              {place.guests.map((guest) => <GuestAccordionRow key={guest.guestId} guest={guest} />)}
            </div>
          </div>
        </CSSTransition>
      </div>);
  }
}

export default GuestAccordionSection;
